import React, { useEffect, useState } from "react";

import { Button, Form, Input, Modal } from "semantic-ui-react";

import ButtonLoadCheck from "react-lib/appcon/common/ButtonLoadCheck";
import { DateTextBox } from "react-lib/apps/common";
import { formatDate } from "react-lib/utils/dateUtils";

import moment from "moment";

// ======================= Constants =======================
export const BACKUP_RECEIPT_CARD = "ModBackupReceiptTemplate";

const DOWNLOAD_ACTION = "DOWNLOAD_BACKUP_RECEIPT";
const EMAIL_ACTION = "SEND_BACKUP_RECEIPT_EMAIL";

// ======================= Types =======================
type ModBackupReceiptTemplateProps = {
  open: boolean;
  setProp: any;
  runSequence: (params: any) => any;
  buttonLoadCheck?: Record<string, any>;
  onClose: () => void;
};

// ======================= Component =======================
const ModBackupReceiptTemplate = (props: ModBackupReceiptTemplateProps) => {
  const [date, setDate] = useState<string>("");
  const [emails, setEmails] = useState<string>("");

  useEffect(() => {
    if (props.open) {
      setDate(formatDate(moment()));
      setEmails("")
    }
  }, [props.open]);

  const handleDownload = () => {
    props.runSequence({
      sequence: "SettingPackage",
      action: DOWNLOAD_ACTION,
      card: BACKUP_RECEIPT_CARD,
      date,
    });
  };

  const handleSendEmail = () => {
    props.runSequence({
      sequence: "SettingPackage",
      action: EMAIL_ACTION,
      card: BACKUP_RECEIPT_CARD,
      date,
      emails: emails
        .split(",")
        .map((email) => email.trim())
        .filter(Boolean),
      onSuccess: props.onClose,
    });
  };

  return (
    <Modal open={props.open} size="mini" closeIcon onClose={props.onClose}>
      <Modal.Header>ดาวน์โหลด Excel ราคาแพ็กเกจ (ออกใบเสร็จแบบ Manual)</Modal.Header>

      <Modal.Content>
        <Form>
          <Form.Field>
            <label>วันที่ของราคาแพ็กเกจ</label>
            <DateTextBox value={date} onChange={(value: string) => setDate(value)} />
          </Form.Field>

          <Form.Field>
            <label>ส่งไปที่อีเมล (คั่นหลายอันด้วย , — ไม่ระบุ = ใช้อีเมลตั้งต้นของระบบ)</label>
            <Input
              placeholder="name@example.com"
              value={emails}
              onChange={(e, { value }) => setEmails(value)}
            />
          </Form.Field>
        </Form>
      </Modal.Content>

      <Modal.Actions>
        <Button size="small" onClick={props.onClose}>
          ปิด
        </Button>

        <ButtonLoadCheck
          setProp={props.setProp}
          onClick={handleSendEmail}
          paramKey={`${BACKUP_RECEIPT_CARD}_${EMAIL_ACTION}`}
          buttonLoadCheck={props.buttonLoadCheck?.[`${BACKUP_RECEIPT_CARD}_${EMAIL_ACTION}`]}
          disabled={!date}
          size="small"
          color="blue"
          name={EMAIL_ACTION}
          title="ส่งอีเมล"
        />

        <ButtonLoadCheck
          setProp={props.setProp}
          onClick={handleDownload}
          paramKey={`${BACKUP_RECEIPT_CARD}_${DOWNLOAD_ACTION}`}
          buttonLoadCheck={props.buttonLoadCheck?.[`${BACKUP_RECEIPT_CARD}_${DOWNLOAD_ACTION}`]}
          disabled={!date}
          size="small"
          color="green"
          name={DOWNLOAD_ACTION}
          title="ดาวน์โหลด"
        />
      </Modal.Actions>
    </Modal>
  );
};

ModBackupReceiptTemplate.displayName = "ModBackupReceiptTemplate";

export default React.memo(ModBackupReceiptTemplate);
